import { FiltersOptionsResponse } from '../schemas/filter.js';
import { FiltersOptions } from '../types/common.js';

export const transformFiltersResponse = (
  platformsMeta: FiltersOptionsResponse,
) => {
  let filters: Omit<FiltersOptions, 'types'> = {
    channels: [],
    categories: [],
    onlineChannels: [],
    offlineChannels: [],
  };

  if (platformsMeta.channels) {
    filters = {
      ...filters,
      ...platformsMeta,
      onlineChannels: platformsMeta.channels.filter(
        (item) => item.type === 'online',
      ),
      offlineChannels: platformsMeta.channels.filter(
        (item) => item.type === 'offline',
      ),
    };
  }

  return filters;
};
